export const geFileErrorTypes = (errors) => {
  const result = errors?.map(({ type }) => type);
  return result ? [...new Set(result)] : [];
};
